var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "float-msg" },
    [_c("Robot"), _vm._v(" "), _c("Share", { staticClass: "fl-bottom" })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }